import './sass/App.scss';
import MapSimple from './MapSimple';
import MapSimpleAuthCheck from './MapSimpleAuthCheck';
import AppController from './components/AppController';
import Map from './Map';
import Trends from './Trends';
import UIControls from './UIControls';
import Snapshot from './components/Snapshot';
import MapTooltip from './components/MapTooltip';
import LocalImpactBox from './components/LocalImpactBox';
import { InterfaceProvider } from './store/InterfaceProvider';
import { generateStyleLayers, generateDataSlugList, mergeStyleLayersJson } from './utils/DataTransformation';
import Legend from './components/Legend';
import MapTitle from './MapTitle';
import DataTable from './components/DataTable';
import ErrorWindow from './ErrorWindow';

// generateStyleLayers();
// generateDataSlugList();
// mergeStyleLayersJson();
document.body.classList.remove('dynamic-loading'); //remove spinner added from embed code

function App() {
    return (
        <div id="fa-injury-dash" role="application" aria-label="Firearm Injury" className="App">
            <InterfaceProvider>
                <AppController />
                <ErrorWindow />
                <UIControls />
                <MapTooltip />
                <MapTitle />
                <Legend />
                {/* <MapSimple /> */}
                {/* <MapSimpleAuthCheck /> */}
                <Map />
                <Snapshot />
                {/* <LocalImpactBox /> */}
                <Trends />
                <DataTable />
            </InterfaceProvider>
        </div>
    );
}

export default App;
